import { CAboutRepositoryImpl } from 'features/about-us/data/repositories/about-repository-impl';
import { ILabs } from 'features/about-us/domain/entities/lab-images';
import { GetLabs } from 'features/about-us/domain/usecases/getLabs';
import React, { createContext } from 'react';

type AboutContextProps = {
	loading: boolean;
	error: string;
	labs: ILabs[];
	getLabs: () => Promise<void>
}

const AboutContext = createContext({} as AboutContextProps);

export const AboutProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	const [labs, setLabs] = React.useState([] as ILabs[]);
	const [loading, setLoading] = React.useState(false);
	const [error, setError] = React.useState('');

	const aboutRepository = new CAboutRepositoryImpl();

	const getLabs = async () => {
		setLoading(true);
		const labsUseCase = new GetLabs(aboutRepository);
		const labsResult = await labsUseCase.call();
		if (labsResult.isRight()) {
			setLabs(labsResult.value);
		} else {
			setError(labsResult.error);
		}
		setLoading(false);
	};

	const value = React.useMemo(() => ({
		labs,
		loading,
		error,
		getLabs,
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}), [labs, loading, error]);

	return <AboutContext.Provider value={value}>{children}</AboutContext.Provider>;
};

export default function useAbout() {
	return React.useContext(AboutContext);
}
